import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { addUpdateCompanyInfoUrl, ADD_UPDATE_COMPANY_INFO_ACTION_TYPE, getAddUpdatecompanyInfoDetails, GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE, headers, UPDATE_MEMBERSHIP_FILE_ACTION_TYPE, updateMembershipFileUrl } from "../../utils/constants"
import moment from 'moment';

export const company_info_add_update_action = (clientId, orderId, firstName, lastName, designation, companyName, addressLine1, addressLine2, cityID, stateID, countryid, pincode, mobile1, mobile2, telephone, primaryEmailID, secondaryEmailID, website, iS_SameAsAbove, inv_FirstName, inv_LastName, inv_Designation, inv_CompanyName, inv_AddressLine1, inv_AddressLine2, inv_CityID, inv_StateID, inv_Countryid, inv_Pincode, inv_Mobile1, inv_Mobile2, inv_Telephone, inv_PrimaryEmailID, inv_SecondaryEmailID, inv_Website, companyRegistrationNo, panNo, nameOnPanCard, gSTNo, companyStatusID, tanNo, uINNo, accountName, accountNo, accountType, bankName, branchName, IFSCCode, EventCordinatorName, EventCordinatorDesignation, EventCordinatorEmail, EventCordinatorMobile, PrimaryContactName, PrimaryContactDesignation, PrimaryContactEmail, PrimaryContactMobile) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')),
            ClientID: clientId != '' ? clientId : null,
            OrderID: orderId != '' ? orderId : null,

            FirstName: firstName != '' ? firstName : null,
            LastName: lastName != '' ? lastName : null,
            Designation: designation != '' ? designation : null,
            CompanyName: companyName != '' ? companyName : null,
            AddressLine1: addressLine1 != '' ? addressLine1 : null,
            AddressLine2: addressLine2 != '' ? addressLine2 : null,
            CityID: cityID != '' ? cityID : null,
            StateID: stateID != '' ? stateID : null,
            Countryid: countryid != '' ? countryid : null,
            Pincode: pincode != '' ? pincode : null,
            Mobile1: mobile1 != '' ? mobile1 : null,
            Mobile2: mobile2 != '' ? mobile2 : null,
            Telephone: telephone != '' ? telephone : null,
            PrimaryEmailID: primaryEmailID != '' ? primaryEmailID : null,
            SecondaryEmailID: secondaryEmailID != '' ? secondaryEmailID : null,
            Website: website != '' ? website : null,
            IS_SameAsAbove: iS_SameAsAbove != '' ? iS_SameAsAbove : false,
            Inv_FirstName: inv_FirstName != '' ? inv_FirstName : null,
            Inv_LastName: inv_LastName != '' ? inv_LastName : null,
            Inv_Designation: inv_Designation != '' ? inv_Designation : null,
            Inv_CompanyName: inv_CompanyName != '' ? inv_CompanyName : null,
            Inv_AddressLine1: inv_AddressLine1 != '' ? inv_AddressLine1 : null,
            Inv_AddressLine2: inv_AddressLine2 != '' ? inv_AddressLine2 : null,
            Inv_CityID: inv_CityID != '' ? inv_CityID : null,
            Inv_StateID: inv_StateID != '' ? inv_StateID : null,
            Inv_Countryid: inv_Countryid != '' ? inv_Countryid : null,
            Inv_Pincode: inv_Pincode != '' ? inv_Pincode : null,
            Inv_Mobile1: inv_Mobile1 != '' ? inv_Mobile1 : null,
            Inv_Mobile2: inv_Mobile2 != '' ? inv_Mobile2 : null,
            Inv_Telephone: inv_Telephone != '' ? inv_Telephone : null,
            Inv_PrimaryEmailID: inv_PrimaryEmailID != '' ? inv_PrimaryEmailID : null,
            Inv_SecondaryEmailID: inv_SecondaryEmailID != '' ? inv_SecondaryEmailID : null,
            Inv_Website: inv_Website != '' ? inv_Website : null,
            CompanyRegistrationNo: companyRegistrationNo != '' ? companyRegistrationNo : null,
            PanNo: panNo != '' ? panNo : null,
            NameOnPanCard: nameOnPanCard != '' ? nameOnPanCard : null,
            GSTNo: gSTNo != '' ? gSTNo : null,
            CompanyStatusID: companyStatusID != '' ? companyStatusID : null,
            TanNo: tanNo != '' ? tanNo : null,
            UINNo: uINNo != '' ? uINNo : null,
            AccountName: accountName != '' ? accountName : null,
            AccountNo: accountNo != '' ? accountNo : null,
            AccountType: accountType != '' ? accountType : null,
            BankName: bankName != '' ? bankName : null,
            BranchName: branchName != '' ? branchName : null,
            IFSCCode: IFSCCode != '' ? IFSCCode : null,
            EventCordinatorName: EventCordinatorName != '' ? EventCordinatorName : null,
            EventCordinatorDesignation: EventCordinatorDesignation != '' ? EventCordinatorDesignation : null,
            EventCordinatorEmail: EventCordinatorEmail != '' ? EventCordinatorEmail : null,
            EventCordinatorMobile: EventCordinatorMobile != '' ? EventCordinatorMobile : null,
            PrimaryContactName: PrimaryContactName != '' ? PrimaryContactName : null,
            PrimaryContactDesignation: PrimaryContactDesignation != '' ? PrimaryContactDesignation : null,
            PrimaryContactEmail: PrimaryContactEmail != '' ? PrimaryContactEmail : null,
            PrimaryContactMobile: PrimaryContactMobile != '' ? PrimaryContactMobile : null,
        }
        console.log("data----------", mapdata)
        const res = await axiosPost(addUpdateCompanyInfoUrl, mapdata, headers);

        dispatch({
            type: ADD_UPDATE_COMPANY_INFO_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};


export const get_company_info_Details_action = (clientId, OrderID) => async (dispatch) => {
    try {
        const mapdata = {
            ClientId: clientId != '' ? clientId : null,
            OrderID: OrderID != '' ? OrderID : null,
            UserId: OrderID != '' ? null : parseInt(sessionStorage.getItem('userId'))
        }
        console.log("data----------**", mapdata)
        const res = await axiosGet(getAddUpdatecompanyInfoDetails, mapdata, headers);

        dispatch({
            type: GET_ADD_UPDATE_COMPANY_INFO_DETAILS_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const update_membership_file_action = (orderId, formFile, formFileType, fileName, flag) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(sessionStorage.getItem('userId')),
            OrderID: orderId,
            Is_Membership: flag == 1 ? 1 : 0,
            FormFile: formFile,
            FormFileType: formFileType,
            FileName: fileName,
            Flag: flag,
        }
        console.log("data----------**", mapdata)
        const res = await axiosPost(updateMembershipFileUrl, mapdata, headers);

        dispatch({
            type: UPDATE_MEMBERSHIP_FILE_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
